// extracted by mini-css-extract-plugin
module.exports = {"container":"EndScreen_container__2K4dr","message":"EndScreen_message__1QTPw","button":"EndScreen_button__tdxM6"};